<div class="dashboard-wrapper">
  <div class="dashboard-info-container">
    <div class="dashboard-info__titles">
      <h1 class="dashboard-info__titles-main">Social Media Dashboard</h1>
      <p class="dashboard-info__titles-info">Total Followers: 23,004</p>
    </div>
    <div class="dashboard-info__control">
      <p *ngIf="isDarkTheme" class="dashboard-info__control-title">
        Light Mode
      </p>
      <p *ngIf="!isDarkTheme" class="dashboard-info__control-title">
        Dark Mode
      </p>
      <app-toggle-slider></app-toggle-slider>
    </div>
  </div>

  <div class="dashboard-top-container">
    <app-dashboard-card-big
      *ngFor="let bigCardsdata of bigCardsdata"
      colorClass="{{ bigCardsdata.colorClass }}"
      iconLink="{{ bigCardsdata.iconLink }}"
      username="{{ bigCardsdata.username }}"
      followersNumber="{{ bigCardsdata.followersNumber }}"
      followersNumberToday="{{ bigCardsdata.followersNumberToday }}"
      statusIconLink="{{ bigCardsdata.statusIconLink }}"
      statusColor="{{ bigCardsdata.statusColor }}"
    ></app-dashboard-card-big>
  </div>

  <div class="dashboard-main-container">
    <h2 class="dashboard-main__title">Overview - Today</h2>
  </div>

  <app-dashboard-today-progress
    class="dashboard-today-container"
  ></app-dashboard-today-progress>
</div>
